import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { filter, interval, takeWhile, tap } from 'rxjs';
import { OnboardingFlowService } from '../../services/onboarding-flow.service';

//TODO: add smooth animations when counting

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-onboarding-preparation',
  templateUrl: './preparation.component.html',
  styleUrls: ['./preparation.component.scss'],
})
export class PreparationComponent implements OnInit, OnDestroy {
  counter = 5;
  blinkState = 'visible';

  private isActive = true;
  private duration = Math.random() * 5000 + 3000;

  constructor(private flowService: OnboardingFlowService) {}

  ngOnInit(): void {
    const intervalDuration = this.duration / this.counter;

    interval(intervalDuration)
      .pipe(
        takeWhile(() => this.isActive),
        tap(() => this.counter--),
        filter(() => this.counter === 0),
        tap(() => this.flowService.handleFinishedCustomization()),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.isActive = false;
  }
}
